module.exports = __webpack_public_path__ + "img/face_string.e6b074f6.svg";